import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function Solution() {
  const benefits = [
    {
      id: 1,
      title: "Alignment of IT and Business Goals",
      description: 'Ensures IT strategies directly support organizational objectives.',
      icon: "fas fa-exchange-alt", // Relevant icon for aligning goals
    },
    {
      id: 2,
      title: "Cost Optimization",
      icon: "fas fa-hand-holding-usd", // Dollar sign for cost-related topics
      description: 'Reduces unnecessary expenses while maximizing resource utilization.',
    },
    {
      id: 3,
      title: "Enhanced Efficiency and Productivity",
      description: 'Streamlines operations for better performance and output.',
      icon: "fas fa-tachometer-alt", // Chart showing progress for efficiency
    },
    {
      id: 4,
      title: "Access to Expertise and Best Practices",
      description: ' Leverages industry knowledge for superior outcomes.',
      icon: "fas fa-chalkboard-teacher", // Business person for expertise
    },
    {
      id: 5,
      title: "Improved Security and Risk Management",
      description: 'Strengthens defenses and minimizes potential vulnerabilities.',
      icon: "fas fa-lock", // Shield for security and protection
    },
    {
      id: 6,
      title: "Agility and Flexibility",
      description: 'Adapts quickly to changing market and business demands.',
      icon: "fas fa-robot", // Robot for agility and automation
    },
    {
      id: 7,
      title: "Accelerated Digital Transformation",
      description: 'Speeds up the adoption of advanced technologies.',
      icon: "fas fa-rocket", // Gear for transformation and technology
    },
    {
      id: 8,
      title: "Scalability for Future Growth",
      description: 'Enables seamless expansion to meet growing demands.',
      icon: "fas fa-chart-line", // Arrows for scalability and growth
    },
    {
      id: 9,
      title: "Competitive Advantage",
      description: 'Positions businesses to outperform industry rivals.',
      icon: "fas fa-trophy", // Trophy for competition and advantage
    },
  ];
  return (
    <>
      <section className="py-5 text-light" style={{ backgroundColor: "#141b29" }}>
        <Container>
          {/* <h6 className="text-uppercase text-center text-info mb-2">Key Benefits</h6> */}
          <h2 className="text-center mb-5">Key Benefits</h2>
          <Row className="g-4">
            {benefits.map((benefit) => (
              <Col md={4} className="text-center mb-5" key={benefit.id}>
                <Row>
                  <Col md={4}>
                    <i className={`${benefit.icon} fa-2x text-info mb-3`}></i>
                  </Col>
                  <Col md={8}>
                    <h5 style={{ textAlign: 'left' }}>{benefit.title}</h5>
                    <h6 style={{ color: '#9b9aad', textAlign: 'left' }}>{benefit.description}</h6>
                  </Col>
                </Row>


              </Col>
            ))}
          </Row>
        </Container>
      </section>

    </>
  )
}